/** Moderation-facing account state. Single source of truth, shared by the Worker's DB schema and the admin API contract. */
export const ACCOUNT_STATUSES = ["ACTIVE", "SUSPENDED", "BANNED"] as const;
export type AccountStatus = (typeof ACCOUNT_STATUSES)[number];
